"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GiftCardOrderPlaytest = exports.RedeemPackage = exports.RedeemTypeEnum = exports.RedeemType = exports.CombinedUserPatchBody = void 0;
const zod_1 = require("zod");
const types_1 = require("../../types");
// These are the fields that can be updated by the user's themselves
exports.CombinedUserPatchBody = zod_1.z.object({
    user: types_1.UserCoreDoc.pick({
        email: true,
    })
        .partial()
        .optional(),
    expUser: types_1.ExpUserDoc.pick({
    // no fields currently allowed anymore
    })
        .partial()
        .optional(),
});
var RedeemType;
(function (RedeemType) {
    RedeemType["TREMENDOUS_GIFT_CARD"] = "TREMENDOUS_GIFT_CARD";
    RedeemType["TREMENDOUS_DONATION"] = "TREMENDOUS_DONATION";
})(RedeemType || (exports.RedeemType = RedeemType = {}));
exports.RedeemTypeEnum = zod_1.z.nativeEnum(RedeemType);
exports.RedeemPackage = zod_1.z.object({
    id: zod_1.z.string(),
    type: exports.RedeemTypeEnum,
    name: zod_1.z.string(),
    amount: zod_1.z.number(),
    coins: zod_1.z.number(),
    piggy: zod_1.z.number(),
});
// The PBR backend has their own GiftCardOrder type, so appending Playtest to make it clear they differ
exports.GiftCardOrderPlaytest = zod_1.z.object({
    id: zod_1.z.string(),
    type: exports.RedeemTypeEnum,
    userId: zod_1.z.string(),
    createdAt: types_1.FTimestamp,
    amount: zod_1.z.number(),
    orderData: types_1.TremendousOrderData,
    piggyBanks: zod_1.z.number(),
    coins: zod_1.z.number(),
});
